// import draw from './draw';
import store from '../../store';
// import { zoom } from 'd3-zoom'; // eslint-disable-line
// import { zoomParameters } from '../../actions/index';

const { getState } = store;

// function zoomed() {
//   const { initial } = getState();
//   const { elements } = initial;
//   const {
//     context,
//     props,
//   } = elements;
//   const { transform } = d3.event;

//   context.save();
//   context.clearRect(0, 0, props.width, props.height);
//   context.translate(transform.x, transform.y);
//   context.scale(transform.k, transform.k);
//   draw({ strokeStyle: '#000', lineWidth: 0.1 });
//   context.restore();
// }

// const zoomI = zoom().scaleExtent([1, 10]).on('zoom', zoomed);

export function mountZoom(event) {
  const { initial } = getState();
  const { elements } = initial;
  const {
    // context,
    container,
    path,
    props,
  } = elements;

  const bounds = path.bounds(event);
  const dx = bounds[1][0] - bounds[0][0];
  const dy = bounds[1][1] - bounds[0][1];
  const x = (bounds[0][0] + bounds[1][0]) / 2;
  const y = (bounds[0][1] + bounds[1][1]) / 2;
  const scale = 0.9 / Math.max(dx / props.width, dy / props.height);
  const translate = [(props.width / 2) - (scale * x), (props.height / 2) - (scale * y)];
  // dispatch(zoomParameters({ scale, translate }));

  // const { canvas } = context;
  container
    // .transition()
    // .duration(750)
    .attr('transform', `translate(${translate}) scale(${scale})`);

  // container.select('.path__fronteira')
  //   .style('stroke', '#fff')
  //   .style('stroke-width', `${3 / scale}px`);

  // MÉTODO COM TRANSIÇÃO
  // select(canvas)
  //   .transition()
  //   .duration(750)
  //   .call(
  //     zoomI.transform,
  //     d3.zoomIdentity
  //       .translate(translate[0], translate[1])
  //       .scale(scale)
  //   );
  // MÉTODO SEM TRANSIÇÃO
  // context.save();
  // context.clearRect(0, 0, props.width, props.height);
  // context.translate(translate[0], translate[1]);
  // context.scale(scale, scale);
  // // draw({ strokeStyle: '#000', lineWidth: 0.2 });
  // context.restore();
}

export function unmountZoom() {
  const { initial } = getState();
  const { elements } = initial;
  const { container } = elements;
  container.attr('transform', '');
  container.select('.path__fronteira')
    .style('stroke', '#000')
    .style('stroke-width', '1');
  // draw();
}



// WEBPACK FOOTER //
// ./src/components/mapa/zoom.js